import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject } from "rxjs";

export class QuestionsService {
  private classroomId: string | undefined;

  constructor(private _stats = new StatsRest()) {
    this.classroomId = localStorage.getItem("objClassroomId") ?? undefined;
  }

  questions$ = new BehaviorSubject([]);
  questions = this.questions$.asObservable();

  chat$ = new BehaviorSubject([]);
  chat = this.chat$.asObservable();

  getQuestionsFromObjectiveStats(
    objectiveId: string,
    params: QueryParams
  ): void {
    this._stats
      .getQuestionsFromObjectiveStats(objectiveId, {
        ...params,
        classroomId: this.classroomId,
      })
      .subscribe({
        next: (response) => {
          this.questions$.next(response);
        },
      });
  }

  getChatQuestionsFromObjectiveStats(
    objectiveId: string,
    params: QueryParams
  ): void {
    this._stats
      .getChatQuestionsFromObjectiveStats(objectiveId, {
        ...params,
        classroomId: this.classroomId,
      })
      .subscribe({
        next: (response) => {
          this.chat$.next(response);
        },
      });
  }
}
